import React from "react"
import { Flex } from "@jjordy/layout"

export interface CenterProps {
  children: React.ReactNode
  [rest: string]: any
}

export default function Center({ children, ...rest }: CenterProps) {
  return (
    <Flex align="center" justify="center" {...rest}>
      {children}
    </Flex>
  )
}
